import form from './form'

// validator decorators
export const passwordDecorator = fn => values =>
  fn(values[form.password.name])

export const passwordAndConfPassDecorator = fn => values =>
  fn(values[form.password.name], values[form.confirmPassword.name])
